<template>
  <div class="organisation-details-view-container" v-if="organisationData">
    <div class="header-container">
      <div class="header-top" v-if="isAdmin">
        <div class="arrow">
          <RouterLink :to="{ name: 'Organisation' }"
            ><i class="material-icons-outlined align-middle">arrow_back</i>
          </RouterLink>
        </div>
        <div class="navigation-details">
          <span class="navigation-details-previous">
            <RouterLink :to="{ name: 'Organisation' }">Organisations /</RouterLink></span
          >
          <span>Organisation Details</span>
        </div>
      </div>

      <div class="header-bottom">
        <p class="header-heading">{{ organisationData.name }}</p>
      </div>
    </div>
    <div class="tabs">
      <div class="tabs-container">
        <button
          v-for="tab in filteredTabs"
          :key="tab.id"
          class="tab"
          @click="handleTabClick(tab.id)"
          :class="{ active: activeTab === tab.id }"
        >
          {{ tab.name }}
        </button>
      </div>

      <div class="tab-content-container">
        <div
          class="component-container"
          v-for="tab in filteredTabs"
          :key="tab.id"
          v-show="activeTab === tab.id"
        >
          <component :is="tab.component" :organisation="organisationData"></component>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
  <!-- ändra -->
</template>

<script>
  import Settings from '@/components/admin/OrganisationDetails/Settings.vue';
  import Licenses from '@/components/admin/OrganisationDetails/Licenses.vue';
  import Users from '@/components/admin/OrganisationDetails/Users.vue';
  import Roles from '@/components/admin/OrganisationDetails/Roles.vue';
  import Integrations from '@/components/admin/OrganisationDetails/Integrations.vue';
  import { GET_ORGANISATION_AS_ADMIN, ORGANISATION_REQUEST } from '@/store/actions/organisation';

  export default {
    name: 'OrganisationDetails',
    components: {
      Settings,
      Licenses,
      Users,
      Roles,
      Integrations,
    },
    data() {
      return {
        tabs: [
          { id: 'settings', name: 'Settings', component: Settings, requiresAdmin: false },
          { id: 'licenses', name: 'Licenses', component: Licenses, requiresAdmin: false },
          { id: 'users', name: 'Users', component: Users, requiresAdmin: false },
          { id: 'roles', name: 'Roles', component: Roles, requiresAdmin: false },
          {
            id: 'integrations',
            name: 'Integrations',
            component: Integrations,
            requiresAdmin: true,
          },
        ],
        activeTab: this.$route.meta.id || 'settings',
      };
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdministrator;
      },
      organisationData() {
        return this.$store.state.organisation.organisation;
      },
      organisationId() {
        return this.$route.params.organisation_id;
      },
      filteredTabs() {
        return this.tabs.filter((tab) => !tab.requiresAdmin || this.isAdmin);
      },
    },
    methods: {
      handleTabClick(tabId) {
        this.activeTab = tabId;

        const currentRoute = this.$route.path;
        const newRoute = `/organisation/${this.organisationId}/${tabId}`;

        if (currentRoute !== newRoute) {
          this.$router.push(newRoute);
        }
      },
      setActiveTabFromRoute() {
        const routeId = this.$route.meta.id;
        const currentTabIndex = this.tabs.findIndex((tab) => tab.id === routeId);
        if (currentTabIndex !== -1) {
          this.activeTab = routeId;
        }
      },
    },
    async mounted() {
      this.setActiveTabFromRoute();
    },
  };
</script>

<style lang="scss" scoped>
  .header-container {
    // border: 2px solid blue;
    padding: 48px 0px 0px;
    color: $primaryText;
    color: $primaryText;
    display: grid;
    gap: 24px;

    .header-top {
      // border: 2px solid pink;
      display: grid;
      grid-template-columns: auto auto 20fr;
      font-size: 16px;
      gap: 20px;
      font-weight: bold;

      .material-icons-outlined {
        color: $primaryText;
      }

      .material-icons-outlined:hover {
        color: $primaryRed;
      }

      .navigation-details {
        display: flex;
        justify-content: flex-start;
        gap: 3px;
        font-family: Poppins;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
      }

      .navigation-details-previous {
        color: $secondaryText;

        a {
          color: $secondaryText;

          &:hover {
            color: $primaryText;
            text-decoration: none;
          }
        }
      }
    }

    .header-bottom {
      margin-bottom: 40px;
    }

    .header-heading {
      font-size: 25px;
      margin-bottom: 0px;
    }
  }
  .organisation-details-view-container {
    font-family: 'Poppins';
    margin: 0;
    padding: 0;
    padding-left: 30px;
    padding-right: 30px;
    display: grid;
    grid-auto-rows: 177px 1fr;
    height: 100vh;
    background-color: $backgroundGrey;
  }

  .tabs {
    display: grid;
    grid-template-rows: 34px auto;
    height: 100%;
    overflow: hidden;
  }
  .tabs-container {
    width: 100;
    display: flex;
    height: 34px;
  }

  .tab-content-container {
    overflow: hidden;
    height: 100%;
    padding-bottom: 30px;
  }

  .tab {
    border: none;
    background-color: transparent;
    font-size: 0.9375rem;
    color: $secondaryText;
    display: flex;
    align-items: end;
    justify-content: center;
    border-bottom: 2px solid $lineGrey;
    padding-bottom: 3px;
    flex: auto;
  }

  .component-container {
    height: 100%;
  }

  .tab:hover {
    color: $primaryText;
  }

  .tab.active {
    border-bottom: 2px solid $primaryRed;
    padding-bottom: none;
    color: $primaryText;
  }
</style>
